export default {
  'en-us': require('./locale/en-us.js').default,
  'zh-cn': require('./locale/zh-cn.js').default,
};
